<template>
  <div>
    <div class="ml-md-3 mt-md-3 mb-3 search-wrapper">
      <div>
        <label class="d-md-inline pt-2 col-md-4 col-lg-2 text-left px-0 my-0">
          所在地
        </label>
        <div class="d-md-inline text-left">
          <select
            class="d-inline form-control col-4 col-md-2 ml-md-2"
            @change="changePref()"
            v-model="search.TODO_CD"
          >
            <option
              v-for="pref in prefs"
              :value="pref.TODO_CD"
              :key="pref.TODO_CD"
            >
              {{ pref.TODO_MEI }}
            </option>
          </select>
          <select
            class="d-inline form-control col-7 col-md-3 ml-2"
            @change="changeCity()"
            v-model="search.SHIKU_CD"
            :disabled="!cities.HIKINO.length"
          >
            <option
              v-for="city in cities.HIKINO"
              :value="city.SHIKU_CD"
              :key="city.SHIKU_CD"
            >
              {{ city.SHIKU_MEI }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="ml-md-3 mx-auto mb-md-2">
      <label class="d-inline col-3 col-md-2 col-lg-2 px-0">
        {{ hnParamWaName }}先：
      </label>
      <span v-if="isMobile" class="bold blue col-8 col-md-9 px-0">
        {{ !selectedObj ? '選択なし' : _omitText(selectedObj.name, 26) }}
      </span>
      <span v-else class="bold blue col-8 col-md-9 px-0">
        {{ !selectedObj ? '選択なし' : omitText(selectedObj.name, 50) }}
      </span>
    </div>
    <section id="order-master">
      <div v-if="async.transports" class="spinner my-5">
        <md-progress-spinner md-mode="indeterminate" />
      </div>
      <div v-else>
        <md-table
          v-if="transports.length"
          class="black-svg h-300 checkbox"
          v-model="transports"
          md-card
          md-fixed-header
        >
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            @click="selectHikino(item)"
            :class="getTableRowClass(item)"
          >
            <md-table-cell v-if="!isMobile" md-label="">
              <input
                type="radio"
                :id="item.ID"
                :value="item.ID"
                v-model="picked"
              />
            </md-table-cell>
            <md-table-cell :md-label="`${hnParamWaName}先`" md-sort-by="NAME">
              <span v-if="!isMobile"><span v-if="item.SPECIAL_RATE_FLG" class="special-rate">特別料金</span>{{ omitText(item.NAME, 45) }}</span>
              <div v-else class="row">
                <p class="col-3 p-0 bold"><span v-if="item.SPECIAL_RATE_FLG" class="special-rate">特別料金</span>{{ hnParamWaName }}先</p>
                <p class="col-9 p-0">{{ _omitText(item.NAME, 18) }}</p>
              </div>
            </md-table-cell>
            <md-table-cell md-label="住所" md-sort-by="ADDRESS">
              <span v-if="!isMobile">{{ omitText(item.ADDRESS, 45) }}</span>
              <div v-else class="row">
                <p class="col-3 p-0 bold">住所</p>
                <p class="col-9 p-0">{{ _omitText(item.ADDRESS, 18) }}</p>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>
        <div v-else class="text-center my-5 bold">該当データがありません。</div>
      </div>
    </section>
  </div>
</template>

<script>
import Store from '@/store/index.js'
import Mixin from '../mixin/Mixin'
export default {
  name: 'Master',
  props: {
    form: {
      type: Object,
      default: null,
    },
    hnParamWaName: {
      type: String,
      default: null,
    },

    /** エラーが存在するか取得するフラグ */
    isInvalidActive: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [Mixin],
  data: () => ({
    async: {
      transports: false,
    },
    JYUCYU_SHIKI_CD: null,
    cities: {
      // 市区町村配列
      HIKINO: [],
    },
    search: {
      TODO_CD: '',
      TODO_MEI: '',
      SHIKU_CD: '',
      SHIKU_MEI: '',
    },
    transports: [],
  }),
  methods: {
    /**
     * データ初期化処理
     */
    dataInit() {
      this.selectedTableInitial()
      this.TOROKUBAYO_KO_ID = null
      this.form.TOROKUBAYO_KO_ID = ''
      this.form.YUBIN1 = ''
      this.form.YUBIN2 = ''
      this.form.TODO_CD = ''
      this.form.TODO_MEI = ''
      this.form.SHIKU_CD = ''
      this.form.SHIKU_MEI = ''
      this.form.BANCHI = ''
      this.form.MEI = ''
      this.form.TEL = ''
      this.form.YUSO_KBN = ''
      this.form.HCB_ZOKUSEI_CD = ''
      this.form.LANDMARK_KBN = ''
      this.form.TANTO_MEI = ''
      this.form.TEIKYU_BI = ''
      this.form.HANNYUSYUTU_JIKAN = ''
    },
    /**
     * 都道府県選択時の処理
     */
    changePref(isReset = true) {
      return new Promise(async () => {
        this.async.transports = true
        const prefCd = this.search.TODO_CD
        if (isReset) {
          this.search.SHIKU_CD = ''
          this.dataInit()
        }
        this.transports = []
        this.cities = {
          HIKINO: [],
        }
        if (prefCd) await this.setCities(prefCd, 'HIKINO', this.cities)
        this.setTransports()
      })
    },
    /**
     * 市区町村選択時の処理
     */
    async changeCity() {
      this.async.transports = true
      this.dataInit()
      this.selectedTableInitial()
      this.setTransports()
    },
    /**
     * 登録済み引取先選択
     * @param {String} prefCd 都道府県コード
     * @param {String} cityCd 市区町村コード
     */
    selectHikino(item) {
      this.setTableRowClassAndName(item.ID, this.transports)
      this.form.TOROKUBAYO_KO_ID = item.ID
      this.form.AA_FLG = 0
      this.form.YUBIN1 = item.YUBIN_BANGO1
      this.form.YUBIN2 = item.YUBIN_BANGO2
      this.form.TODO_CD = item.TODO_CD
      this.form.TODO_MEI = item.TODO_MEI
      this.form.SHIKU_CD = item.SHIKU_CD
      this.form.SHIKU_MEI = item.SHIKU_MEI
      this.form.BANCHI = item.BANCHI
      this.form.MEI = item.NAME
      this.form.TEL = item.HCB_TEL || item.TEL
      this.form.YUSO_KBN = this.convYusoKbnFromHcb(item.HCB_ZOKUSEI_CD)
      this.form.HCB_ZOKUSEI_CD = item.HCB_ZOKUSEI_CD
      this.form.LANDMARK_KBN = item.LANDMARK_KBN
      this.form.TANTO_MEI = item.TANTO_SYA
      this.form.TEIKYU_BI = item.TEIKYU_BI
      this.form.EIGYO_KAISI_JIKAN = ''
      this.form.EIGYO_SYURYO_JIKAN = ''
      this.form.HANNYUSYUTU_JIKAN = item.HANNYU_JIKAN
    },
    setTransports() {
      this.async.transports = true
      this.getTransports({ cond: this.search }).then((list) => {
        this.transports = list
        this.async.transports = false
      })
    },
  },

  async created() {
    if (this.form.TODO_CD) {
      this.search.TODO_CD = this.form.TODO_CD
      await this.changePref(false)
    }
    this.JYUCYU_SHIKI_CD = Store.state.user.data.JYUCYU_SHIKI_CD
    this.setTransports()
  },

  watch: {
    /** エラーが存在するか取得するフラグ監視 */
    isInvalidActive(val) {
      if (val) {
        this.$emit('setInvalid', this.form.TOROKUBAYO_KO_ID ? false : true)
      }
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.color-on
  background: $baseBlueColor
  color: #fff
.color-off
  background: #fff
  color: $baseBlackColor
.bottom-1
  margin-bottom: 1rem
.yusosaki-mei
  height: 56px

.special-rate
  font-size: 10px;
  background: red;
  color: white;
  padding: 2px;
  font-weight: bold;
</style>



// WEBPACK FOOTER //
// src/components/trial/Master.vue